<template>
    <div class="md-house-listing standard" v-if="exist">
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div class="title">
                <div class="main-title">
                    <div class="mg-title" :class="centerClass" v-if="titleContent" v-html="formatFontSize(titleContent, '--mg-title-size')" style="font-family:var(--mg-title-font);"></div>
                   
                </div>
                <h3
                    class="sub-title"
                    v-if="baseUrl"
                    v-html="
                        $t('md-house-listing.basedOnListing', {
                            href: baseUrl,
                            address: baseListingAddr
                        })
                    "
                ></h3>
                <h3
                    class="sub-title"
                    v-if="!forMoreData && dataType === 'recommend'"
                >
                    {{ subTitle }}
                </h3>
            </div>
            <HouseGrid></HouseGrid>
        </module-box>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import Common from '../index.js';
export default {
    components: {
        HouseGrid: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "modules/md-house/grid-v1_grid"*/ '../../md-house/grid-v1/grid.vue'
            ))
    },
    mixins: [Common]
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';
.md-house-listing.standard {
    > div {
        overflow: visible;
    }
    .title {
        position: relative;
        padding-bottom: 20px;
        .main-title {
            display: flex;
            align-items: baseline;
            justify-content: space-between;
        }
        .mg-title {
            padding: 0;
            text-align: var(--mg-title-align);
        }
        .sub-title {
            font-size: 14px;
            display: inline-block;
            max-width: calc(100% - 60px);
            font-family: var(--font-medium);
            white-space: pre-line;
            color: #a0a3af;
            a {
                color: #03c9ff;
            }
        }
        .center {
            text-align: center;
        }
      
        @include media-600 {
            .mg-title {
                font-size: var(--mg-title-size-mobile);
            }
            .sub-title {
                font-size: 12px;
            }
        }
    }
}
</style>
